<template lang="html">
  <div class="portfolio_wrap">

    <div class="portfolio_main_title">
      <h1>Portfolio</h1>
    </div>

    <transition name="fadeleft" mode="out-in">
      <div v-if="activeFotoDisplay" class="gallery_wrap">

        <div class="gallery_container">

          <div class="gallery_photoscroll_wrap">
            <div class="gallery_photoscroll_container" id="smalldisplay">
              <div
                v-if="photo.Projectid == activeId"
                v-for="photo in fotos" v-bind:style="{'background-image': 'url('+require('../../assets/project/'+photo.Projectid+'_'+photo.Fotoid+'.jpg')+')'}"
                @click="changePhoto(photo.Fotoid)"
                class="gallery_photo_minidisplay"
              ></div>
            </div>
          </div>

          <div class="gallery_photodisplay_wrap">
            <div class="gallery_photodisplay_container" id="bigdisplay">
              <div v-if="photo.Projectid == activeId"
              v-for="photo in fotos"
              v-bind:style="{'background-image': 'url('+require('../../assets/project/'+photo.Projectid+'_'+photo.Fotoid+'.jpg')+')'}"
              class="gallery_photodisplay"
              ></div>
            </div>
          </div>
        </div>

        <div class="gallery_close" @click="gallerygone()"><i class="fas fa-times"></i></div>
        <div class="gallery_info_container">
          <div class="gallery_info_title">
            <h1>{{activeProject.aProjectnaam}}</h1>
          </div>
        </div>
        <div class="gallery_background" @click="gallerygone()"></div>
      </div>
    </transition>

    <div class="portfolio_container">
      <div v-for="item in projecten" class="project_card_wrap">
        <div @click="clickProject(item.Projectid, item.Projectnaam, item.Locatie)" class="project_card_container">
          <div class="project_card_foto" v-bind:style="{'background-image': 'url('+require('../../assets/project/'+item.Projectid+'_1.jpg')+')'}" ></div>
          <div class="project_card_info">
            <div class="project_card_text">
              <h1>{{ item.Projectnaam }}</h1>
              <p>{{ item.Locatie }}</p>
            </div>
            <h2>Bekijk Meer</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return{
      activeProject: {
        aProjectnaam: null, aLocatie: null
      },
      mDisplayActive: 1,
      displayHeight: null,
      activeId: null,
      activeFotoDisplay: false,
      projecten: [
        {Projectid: "1", Projectnaam: "Cityhub", Locatie: 'Utrecht'},
        {Projectid: "2", Projectnaam: "Woonboot", Locatie: 'Nieuwkoop'},
        {Projectid: "3", Projectnaam: "Behangwerk", Locatie: 'Heemstede'},
        {Projectid: "4", Projectnaam: "Winkelpand", Locatie: 'Amersfoort'},
        {Projectid: "5", Projectnaam: "Herenhuis", Locatie: 'Amsterdam'},
        {Projectid: "6", Projectnaam: "Houten huis", Locatie: 'Aalsmeer'}
      ],
      fotos: [
        {Projectid: "1", Fotoid: '1'},
        {Projectid: "1", Fotoid: '2'},
        {Projectid: "1", Fotoid: '3'},
        {Projectid: "1", Fotoid: '4'},
        {Projectid: "1", Fotoid: '5'},
        {Projectid: "1", Fotoid: '6'},
        {Projectid: "1", Fotoid: '7'},

        {Projectid: "2", Fotoid: '1'},
        {Projectid: "2", Fotoid: '2'},

        {Projectid: "3", Fotoid: '1'},
        {Projectid: "3", Fotoid: '2'},

        {Projectid: "4", Fotoid: '1'},
        {Projectid: "4", Fotoid: '2'},
        {Projectid: "4", Fotoid: '3'},

        {Projectid: "5", Fotoid: '1'},
        {Projectid: "5", Fotoid: '2'},
        {Projectid: "5", Fotoid: '3'},
        {Projectid: "5", Fotoid: '4'},

        {Projectid: "6", Fotoid: '1'},
        {Projectid: "6", Fotoid: '2'},
        {Projectid: "6", Fotoid: '3'},
        {Projectid: "6", Fotoid: '4'},
        {Projectid: "6", Fotoid: '5'},
      ]
    }
  },
  methods: {
    clickProject(pId, pNaam, Loc) {
      this.activeId = pId;
      this.activeFotoDisplay = true;
      this.$emit('FotoDisplay');
      this.activeProject.aProjectnaam = pNaam;
      this.activeProject.aLocatie = Loc;
    },
    gallerygone() {
      this.activeFotoDisplay = false;
      this.$emit('FotoDisplay');
    },
    changePhoto(photoId) {
      var bigD = document.getElementById('bigdisplay');
      if(photoId == 1) {
        this.displayHeight = 0;
      }else{
        this.displayHeight = photoId*bigD.clientHeight-bigD.clientHeight;
      }

      bigD.style.top = '-'+this.displayHeight+'px';
      this.sDisActive(photoId);
      //.classList.add('smallDisplayActive');
    },
    sDisActive(Sda) {
      document.getElementById('smalldisplay').children[Sda - 1].classList.add('smallDisplayActive');
    }
  }
}
</script>

<style lang="css">
.portfolio_main_title{
  width: 100%;
  height: 50px;
  padding: 25px 0;
  display: none;
  align-items: center;
}

.gallery_info_container{
  position: fixed;
  z-index: 5000;
  //top: 0;
  left: 0;

}

.gallery_photoscroll_container .smallDisplayActive{
  opacity: 1;
}

.gallery_close{
  position: fixed;
  margin: 25px;
  width: 50px;
  height: 50px;
  background: #fff;
  right: 0;
  //top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 200;
  border-radius: 5px;
  box-shadow: 0 3px 6px rgba(0,0,0,0.05), 0 3px 6px rgba(0,0,0,0.10);
  cursor: pointer;
}

.gallery_close i{
  font-size: 25px;
  color: #222;
}

.gallery_wrap{
  position: fixed;
  width: 100%;
  height: calc(100% - 60px);
  display: flex;
  //justify-content: center;
  //align-items: center;
  //align-self: flex-start;
  z-index: 9000;
  top: 0;
  left: 0;
  max-width: 1700px;
}

.gallery_container{
  width: 800px;
  height: 300px;
  display: flex;
  flex-direction: row;
  border-radius: 5px;
  padding: 5px;
  background: #fff;
  overflow: hidden;
  z-index: 902;
  margin: 100px 25px 0 25px;
  box-shadow: 0 3px 6px rgba(0,0,0,0.05), 0 3px 6px rgba(0,0,0,0.10);
}

.gallery_background{
  width: 100%;
  height: 100%;
  position: absolute;
  background: rgba(255,255,255,1);
  cursor: pointer;
  position: fixed;
}

.gallery_photoscroll_wrap{
  height: 100%;
  width: 150px;
  overflow-y: scroll;
  border-radius: 5px;
}

.gallery_photoscroll_wrap::-webkit-scrollbar {
  width: 7px;
}

.gallery_photoscroll_wrap::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.gallery_photoscroll_wrap::-webkit-scrollbar-thumb {
  background: #222;
  border-radius: 5px;
}

.gallery_photoscroll_container{
  width: 135px;
}

.gallery_photo_minidisplay{
  width: 100%;
  height: 80px;
  background-image: url('../../assets/project/1_1.jpg');
  background-position: center;
  background-size: 110%;
  opacity: 0.5;
  margin: 0 0 5px 0;
  transition: 0.2s ease;
}

.gallery_photo_minidisplay:hover{
  background-size: 115%;
  opacity: 1;
  cursor: pointer;
  transition: 0.5s ease;
}

.gallery_photodisplay_wrap{
  height: 100%;
  width: calc(100% - 153px);
  margin-left: 7px;
  border-radius: 0 5px 5px 0;
  overflow: hidden;
}

.gallery_photodisplay_container{
  height: 100%;
  position: relative;
  //top: -425px;
}

.gallery_photodisplay{
  width: 100%;
  height: 100%;
  background: url('../../assets/project/1_2.jpg');
  background-position: center;
  background-size: cover;
}

  .portfolio_wrap{
    width: 100%;
    min-height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .portfolio_wrap h1{
    color: #fff;
    font-family: 'Segoe UI', sans-serif;
    font-weight: 300;
  }

  .portfolio_container{
    max-width: 1700px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    padding: 50px 0 50px 0;
  }

  .project_card_wrap{
    padding: 10px;
  }

  .project_card_container{
    width: 450px;
    height: 275px;
    border-radius: 5px;
    box-shadow: 0 3px 6px rgba(0,0,0,0.05), 0 3px 6px rgba(0,0,0,0.10);
    overflow: hidden;
    position: relative;
  }

  .project_card_foto{
    background: linear-gradient(
        rgba(0, 0, 0, 0.0),
        rgba(0, 0, 0, 0.6)
      ),
      url('../../assets/banner/work3.jpg');
    background-size: 120%;
    background-position: center -50px;
    background-repeat: no-repeat;
    width: 100%;
    height: 100%;
    transition: 0.2s ease;
  }

  .project_card_container:hover .project_card_foto{
    background-size: 125%;
    transition: 0.4s ease;
  }

  .project_card_container:hover{
    cursor: pointer;
  }

  .project_card_info{
    width: calc(100% - 20px);
    padding: 10px;
    position: absolute;
    bottom: 0px;
    background: #fff;
  }

  .project_card_info h1{
    font-size: 15px;
    font-weight: 900;
    font-family: 'Segoe UI', sans-serif;
    color: #222;
  }

  .project_card_info p{
    font-size: 10px;
    font-weight: 500;
    font-family: 'Segoe UI', sans-serif;
    color: #777;
  }

  .project_card_info h2{
    font-size: 10px;
    font-weight: 600;
    font-family: 'Segoe UI', sans-serif;
    color: #222;
    position: relative;
    margin: 10px 0 0 0;
  }

  .project_card_info h2:after{
    position: absolute;
    background-color: #222;
    bottom: -5px;
    right: 0;
    content: ' ';
    height: 1px;
    width: 0%;
    transition: 0.3s ease;
  }

  .project_card_container:hover .project_card_info h2:after{
      left: 0;
      width: 100%;
      transition: 0.3s ease;
  }

  .gallery_info_container .gallery_info_title h1{
    color: #222;
    font-family: 'Segoe UI', sans-serif;
    font-size: 25px;
    font-weight: 800;
    line-height: 22px;
    color: #222;
    animation: titleanim 0.8s ease 1;
  }

  .gallery_info_title{
    padding: 25px;
    height: 50px;
    display: flex;
    align-items: center;
  }

  @media only screen and (max-width : 650px) {

    .gallery_photoscroll_wrap::-webkit-scrollbar {
      height: 7px;
    }

    .gallery_wrap{
      height: 100%;
      top: 0;
    }

    .gallery_container{
      flex-direction: column;
    }

    .gallery_photodisplay_wrap{
      width: 100%;
      margin: 5px 0 0 0;
    }

    .gallery_photoscroll_wrap{
      width: 100%;
      height: 100px;
      overflow-x: scroll;
      overflow-y: hidden;
      padding-bottom: 5px;
    }

    .gallery_photoscroll_container{
      display: flex;
      flex-direction: row;
      width: fit-content;
      height: 100%;
      overflow: hidden;
    }

    .gallery_photo_minidisplay{
      height: 100%;
      width: 100px;
      margin: 0 5px 0 0;
    }

    .portfolio_wrap{
      padding: 0px 25px 25px 25px;
      box-sizing: border-box;
    }

    .portfolio_container{
      width: 100%;
      padding: 0px 0;
    }

    .project_card_wrap{
      width: 100%;
      padding: 0;
      margin-bottom: 25px;
    }

    .project_card_container{
      width: 100%;
      height: 250px;
    }

    .project_card_info{
      width: 100%;
      padding: 20px;
      box-sizing: border-box;
    }

    .project_card_info h1{
      font-family: 'Segoe UI', sans-serif;
      font-size: 14px;
      font-weight: 800;
      line-height: 18px;
      color: #222;
      padding-bottom: 5px;
    }

    .project_card_info p{
      font-size: 14px;
    line-height: 18px;
    font-family: 'Segoe UI', sans-serif;
    font-weight: 400;
    color: #888;
    }

    .project_card_info h2{
      margin: 0;
    }

    .project_card_text{
      width: 100%;
      display: flex;
      justify-content: space-between;
    }

    .portfolio_main_title{
      display: flex;
    }

    .portfolio_main_title h1{
      font-family: 'Segoe UI', sans-serif;
      font-size: 25px;
      font-weight: 800;
      line-height: 22px;
      color: #222;
      animation: titleanim 0.8s ease 1;
    }
  }



</style>
